export const DROPPABLE_IDS = {
  CHARACTER_TRAY: "character tray",
  FLOOR_TRAY: "floor tray",
  BOARD: "board",
  SEARCH_TRAY: "search tray",
};
